function HandleOrgchartFailedImageLoad(el) {
  el.parentNode.classList.add("visible-initials")
  el.remove();
}
